/**
 * UIStateOrchestrator.js
 * 
 * Centralizes UI-related state management, hero-image alternation, 
 * and dataset synchronization for the Beta Engine.
 */

import imagesLoaded from 'imagesloaded';

export const applyUIState = (docData, lotNumber) => {
  // Determine body class and dataset changes
  const bodyClassListRemove = ["loaded", "intro"];
  const bodyDatasetActive = "lot";

  // Replicate Hero Alternation Logic
  let randomCat = (Number(sessionStorage.getItem("counter") || 0) % 2 === 0) ? "b" : "a";
  sessionStorage.setItem("counter", Number(sessionStorage.getItem("counter") || 0) + 1);

  // Return root data attributes for App.js to set on #root
  const rootDataAttributes = {
    math: randomCat,
    rsd: docData.rds
  };

  return { docData, lotNumber, bodyClassListRemove, bodyDatasetActive, rootDataAttributes };
};

export const isRenu = (down_type) => {
  return typeof down_type === 'string' && down_type.toLowerCase().includes("renu");
};

export const fpChecker = (fillPower) => {
  let fpValue = parseInt(fillPower, 10); // Ensure fillPower is treated as a number
  if (isNaN(fpValue)) { // Handle cases where fillPower might not be a valid number
    return '0';
  }

  if (fpValue >= 750) {
    return '750';
  } else if (fpValue >= 700) {
    return '700';
  } else {
    return '600';
  }
};

export const triggerSectionTransition = (newActiveSection) => {
  const actions = [];

  // Remove 'addUp' class as part of the initial transition reset (similar to old lookupLott behavior)
  //actions.push({ type: 'remove', className: 'addUp', delay: 0 });

  // Step 1: Initial state for wipe animation
  //actions.push({ type: 'add', className: 'wipeOne', delay: 0 });
  //actions.push({ type: 'remove', className: 'imgUp', delay: 0 }); // Ensure imgUp is off

  // Step 2: Allow a small frame for 'wipeOne' to register before adding 'add'
  //actions.push({ type: 'add', className: 'add', delay: 50 }); // Small delay to let 'wipeOne' start its CSS transition

  // Step 3: Start the main content transition (simulating imagesLoaded 'done')
  //actions.push({ type: 'add', className: 'loaded', delay: 250 });   // Trigger CSS transitions for .il elements
  //actions.push({ type: 'add', className: 'imgUp', delay: 250 });   // Reveal content (e.g., video opacity 1)
  //actions.push({ type: 'add', className: 'wipeLeft', delay: 250 }); // Start the wipeLeft animation

  // Step 4: Remove temporary wipe classes after their animation duration
  //actions.push({ type: 'remove', className: 'wipeLeft', delay: 1510 }); // 250 + 1260
  //actions.push({ type: 'remove', className: 'wipeOne', delay: 1510 }); // 250 + 1260

  return actions;
};

/**
 * trackAnalyticsEvent
 * 
 * Standardized helper for pushing events to the GTM/GA4 dataLayer.
 * @param {Object} eventData - The object to push to dataLayer (e.g., { event: 'pageview', ... })
 */
export const trackAnalyticsEvent = (eventData) => {
  if (process.env.REACT_APP_DISABLE_GA === "true") return;

  try {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(eventData);
    }
  } catch (err) {
    console.warn("Analytics tracking failed:", err);
  }
};

/**
 * Helper function to resolve bespoke configuration based on brand and conditions.
 */
export const getBespokeConfig = (brandPrefix, configMap, data) => {
  const brandConfig = configMap[brandPrefix];
  if (!brandConfig) return null;

  let finalConfig = brandConfig; // Start with the base config

  // Check for nested conditions
  if (brandConfig.grs && data.grs) {
    finalConfig = brandConfig.grs;
  } else if (brandConfig.treatment && data.normalizedTreatment && brandConfig.treatment[data.normalizedTreatment]) {
    finalConfig = brandConfig.treatment[data.normalizedTreatment];
  } else if (brandConfig.email && data.email && brandConfig.email[data.email]) {
    finalConfig = brandConfig.email[data.email];
  } else if (brandConfig.math && data.math && brandConfig.math[data.math]) {
    finalConfig = brandConfig.math[data.math];
  } else if (brandConfig.default) {
    finalConfig = brandConfig.default;
  }

  // Ensure the returned config actually has a bgSrc, otherwise return null
  if (finalConfig && finalConfig.bgSrc) {
    return finalConfig;
  }
  
  return null; 
};



